
export class ClimbingRoute {
    constructor(
        public id: number,
        public dificulty: string,
        public points: number = 1
    ) { }
}